module.exports = __webpack_public_path__ + "img/_1.1cb10bed.png";